module.exports = __webpack_public_path__ + "media/recenzie3.5fceff87.mp4";